import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {AttachmentClassificationResponse} from 'src/api/ProactApiClient';

export const useAttachmentClassificationColumns = () => {
  const columns = useMemo<MRT_ColumnDef<AttachmentClassificationResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'description',
        header: 'Description',
      },
    ],
    []
  );

  return columns;
};
